import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';

import { AuthContextService } from '../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService, NotificationType } from '../_services/notification.service';
import { tap, catchError, map } from 'rxjs/operators';
import { Observable, EMPTY, throwError } from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(public auth: AuthContextService,
    private _notificationService: NotificationService,
    private _route: ActivatedRoute,
    private _router: Router) { }

  getLocation(href) {
    var l = document.createElement("a");
    l.href = href;
    return l.hostname + ":" + l.port;
  }

  nthIndex(str, pat, n) {
    var L = str.length, i = -1;
    while (n-- && i++ < L) {
      i = str.indexOf(pat, i);
      if (i < 0) break;
    }
    return i;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let errorNotificationId = null

    if (!request.headers.has('Content-Type')) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    } else if (request.headers.get('Content-Type') === 'multipart/form-data') {
      request = request.clone({ headers: request.headers.delete('Content-Type') });
    }

    const bypassed_urls = [
      'ciratest.cognicor.com/testbots',
      'ciradev.cognicor.com/testbots',
      'ciradev.cognicor.com:8080',
      'ciradev.cognicor.com:8090',
      'ciratest.cognicor.com:8090',
      'ciratest.cognicor.com:8080',
      'bots.cognicor.com',
      'MultiAgentSystem'
    ]

    // users.findIndex(x => x.username == value);
    // console.log("intercepting "+this.getLocation(request.url))
    // console.log(!(bypassed_urls.findIndex(x => x == this.getLocation(request.url))))
    // (bypassed_urls.findIndex(x => (request.url.indexOf(x) == -1)))

    if (this.auth.isLoggedIn() && (bypassed_urls.findIndex(x => request.url.indexOf(x) > -1) == -1)) {
      const current_url = request.url.split("/")
      if (current_url.pop() === "refresh_auth_token") {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.auth.getToken(true)}`,
            RELEASE_ID: `${this.auth.getReleaseId()._id}`
          }
        });
      } else {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.auth.getToken()}`,
            RELEASE_ID: `${this.auth.getReleaseId()._id}`
          }
        });
      }
    }


    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // do stuff with response if you want
        }
        return event;
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if(err.status === 502 || err.status === 503 || err.status === 0) {
            this._notificationService.showNotification({
              message: 'This page has failed to load our team has been notified. Wait a few minutes and try again. If the problem persists, contact Cira support.',
              type: NotificationType.error,
              isLoading: false
            })
          }
          if (err.status === 401 || err.status === 422) {
            if (request.url.indexOf("MultiAgentSystem") == -1) {
              this.auth.logoutUser();
              return EMPTY
            }
          }
          if (err.status === 403) {
            const notifyID = this._notificationService.notificationID.shift();
            if (notifyID) {
              this._notificationService.changeStatus(notifyID, NotificationType.warning, 'You don\'t have the permission for this operation.');
            } else {
              this._notificationService.showNotification({
                message: ' You don\'t have the permission for this operation.',
                type: NotificationType.warning,
                isLoading: false
              });
        
              console.log('route1', this._route['snapshot']['_routerState']['url']);
              console.log('route2', this._route.snapshot.queryParams['returnUrl']);
              // _routerState: { … }
        
              // _root: Object { value: { … }, children: (1)[…] }
        
              // url: "/project/5d22e211ac05591fa941df4b/settings/ner-annotation"
              if (this.auth.isLoggedIn()) {
                let urlSnap = this._route['snapshot']['_routerState']['url'];
                if (urlSnap.includes('project')) {
                  // let urlRed = urlSnap.slice(0, this.nthIndex(urlSnap, '/', 3));
                  // this._router.navigateByUrl(urlRed + '/ontology-editor');
                } else {
                  this._router.navigateByUrl('/list-va');
                }
              }
            }
          } else if (err.status === 415) {
            const notifyID = this._notificationService.notificationID.shift();
            if (notifyID) {
              this._notificationService.changeStatus(notifyID, NotificationType.warning, 'File type not supported.');
            } else {
              this._notificationService.showNotification({
                message: 'File type not supported.',
                type: NotificationType.warning,
                isLoading: false
              });
            }
          } else if (err.status === 500) {
            const notifyID = this._notificationService.notificationID.shift();
            if (notifyID) {
              this._notificationService.changeStatus(notifyID, NotificationType.warning, 'Something went wrong.We\'re working on it.');
            } else {
              this._notificationService.showNotification({
                message: 'Something went wrong.We\'re working on it.',
                type: NotificationType.warning,
                isLoading: false
              });
            }
          }
        }
        return throwError(err);
      })
    );
  }
}